import { NgModule } from "@angular/core";
import { WebGLModule } from "../webgl/webgl.module";
import { RenderModule } from "../render/render.module";
import { CanvasComponent } from "./canvas.component";
import { CanvasController } from "./canvas-controller.directive";
import { InputManager } from "./input-manager";
var CanvasModule = (function () {
    function CanvasModule() {
    }
    CanvasModule.decorators = [
        { type: NgModule, args: [{
                    imports: [WebGLModule, RenderModule],
                    declarations: [CanvasComponent, CanvasController],
                    providers: [InputManager],
                    exports: [CanvasComponent]
                },] },
    ];
    CanvasModule.ctorParameters = function () { return []; };
    return CanvasModule;
}());
export { CanvasModule };
;
//# sourceMappingURL=canvas.module.js.map